import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import {
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Grid,
    Breadcrumbs,
    IconButton,
    Box,
    Typography,
    Button,
    Switch,
    Tooltip,
    Stack,
} from '@mui/material';
import {
    Add, Info,
    KeyboardArrowDown,
    KeyboardArrowUp,
    Visibility
} from '@mui/icons-material';
import HomeIcon from '@mui/icons-material/Home';
import axios from 'axios';
import { formatarCNPJ, hasPermission, checkPermissionsAndRedirect } from '../../../../configs/functions';
import LinkNavegacao from '../../../common/Link';
import PageTitle from '../../../common/PageTitle';
import { CompanyForm } from './CompanyForm';
import ConfirmDialog from '../../../common/ConfirmDialog';
import CompanyUnits from './CompanyUnits';
import { EditIcon, OfficeIcon, TrashIcon } from '../../../common/Icons';
import { useAppContext } from '../../../../contexts/AppContext';
import { useCommonItems } from '../../../../contexts/CommonItensProvider';
import { checkMaxEmpresas, listaEmpresas, listaFiliais } from './configs/functions';
import { CustomTablePagination } from '../../../common/CustomTablePagination';
import { LoadingTableRow } from '../../../common/LoadingTableRow';
import { EmptyTableRow } from '../../../common/EmptyTableRow';
import { TooltipSelectDisabled } from '../../../common/TooltipSelectDisabled';
import { useModuleContext } from '../../../../contexts/ModuleProvider';
import { FiltersButton } from "../../../common/FiltersButton";
import { CompanyTableFilter } from "./components/CompanyTableFilter";
import { useSearchParams } from "react-router-dom";
import { useIsSempher } from '../../../../configs/functions';

const Row = ({ matriz, actionsAllowed, handleExibirAlerta, handleOpenEditForm, isLimitReached, handleOpenModalFilial, handleUpdateCompanyStatus, handleUpdateCompanyLivenessCheck, dadosUsuario, isSempher }) => {
    const [open, setOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const [active, setActive] = useState(matriz.status === 'ativa');
    const [livenessCheck, setLivenessCheck] = useState(Boolean(matriz.livenessCheck));
    const [equipmentSelection, setEquipmentSelection] = useState(Boolean(matriz.equipmentSelectionRequired));

    const [filiais, setFiliais] = useState(matriz.filiais ?? []);
    const [loaded, setLoaded] = useState(true);

    useEffect(() => {
        setFiliais(matriz.filiais ?? []);
    }, [matriz.filiais]);

    useEffect(() => {
        setActive(matriz.status === 'ativa');
    }, [matriz.status]);

    useEffect(() => {
        setLivenessCheck(Boolean(matriz.livenessCheck));
    }, [matriz.livenessCheck]);

    const deleteEmpresa = (id) => {
        axios.delete(`empresas/${id}`).then((response) => {
            const message = response.data.message ?? 'Matriz inativada com sucesso'
            handleExibirAlerta('Sucesso', message, 'success')
            handleUpdateCompanyStatus(matriz.id, 'inativa')
            setActive(false)
        }).catch(() => {
            handleExibirAlerta('Erro', 'Erro ao executar operação', 'error')
        })

        setOpenDialog(false)
    }

    const handleToggleCompanyStatus = () => {
        if (!hasPermission(["admin", "admin_empresas", "update_empresas"]) && isSempher) {
            handleExibirAlerta('Erro', 'Você não tem permissão para executar esta ação.', 'error')
            return false;
        }

        const novoStatus = (matriz.status === 'ativa') ? 'inativa' : 'ativa'

        axios.patch(`empresas/${matriz.id}`, { status: novoStatus })
            .then((response) => {
                const message = active ? 'Matriz inativada com sucesso' : 'Matriz ativada com sucesso'
                handleExibirAlerta('Sucesso', message, 'success')
                setActive(!active)
                handleUpdateCompanyStatus(matriz.id, novoStatus)
            }).catch(() => {
                handleExibirAlerta('Erro', 'Erro ao executar operação', 'error')
            })
    }

    const handleToggleCompanyLivenessCheck = () => {
        if (!hasPermission(["admin", "admin_empresas", "update_empresas"])) {
            handleExibirAlerta('Erro', 'Você não tem permissão para executar esta ação.', 'error')
            return false;
        }

        const novoValor = !livenessCheck

        axios.patch(`empresas/${matriz.id}`, { liveness_check: novoValor })
            .then((response) => {
                const message = livenessCheck ? 'Checagem inativada com sucesso' : 'Checagem ativada com sucesso'
                handleExibirAlerta('Sucesso', message, 'success')
                setLivenessCheck(novoValor)
                handleUpdateCompanyLivenessCheck(matriz.id, novoValor)
            }).catch(() => {
                handleExibirAlerta('Erro', 'Erro ao executar operação', 'error')
            })
    }

    const handleToggleCompanyEquipmentSelection = () => {
        if (!hasPermission(["admin", "admin_empresas", "update_empresas"])) {
            handleExibirAlerta('Erro', 'Você não tem permissão para executar esta ação.', 'error')
            return false;
        }

        axios.patch(`empresas/${matriz.id}`, { equipment_selection_required: !equipmentSelection })
            .then((response) => {
                const message = equipmentSelection ? 'Obrigatoriedade inativada com sucesso' : 'Obrigatoriedade ativada com sucesso'
                handleExibirAlerta('Sucesso', message, 'success')
                setEquipmentSelection(!equipmentSelection)
            }).catch(() => {
                handleExibirAlerta('Erro', 'Erro ao executar operação', 'error')
            })
    }

    

    const carregaFiliais = () => {
        setLoaded(false)
        listaFiliais(matriz.id, { isFilter: true }).then((res) => {
            setFiliais(res.data)
            console.log(res.data)
        }).catch(() => {
            handleExibirAlerta('Erro', 'Erro ao carregar filiais', 'error')
        }).finally(() => {
            setLoaded(true)
        });
    }

    const handleToggleOpen = () => {
        if (!open && filiais.length === 0) {
            carregaFiliais()
        }
        setOpen(!open)
    }

    const canUpdate = hasPermission(["admin", "admin_empresas", "update_empresas"]) && actionsAllowed;

        console.log(matriz.hasUnites)

    return (
        <>
            <TableRow>
                <TableCell />
                <TableCell align='left'>
                {matriz.hasUnites ? (
                    <span 
                        onClick={handleToggleOpen}
                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'left', justifyContent: 'flex-start'}}
                        aria-label="Detalhes"
                    >
                        {open && filiais.length > 0 ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
                    </span>
                ) : (
                   <span><p style={{textAlign:'left'}}>- </p></span>
                )}
                </TableCell>

                <TableCell align="left" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                    {formatarCNPJ(matriz.cnpj)}
                </TableCell>
                <TableCell align="left" sx={{ fontWeight: 600 }}>{matriz.nomeFantasia}</TableCell>
                <TableCell align="left">{`${matriz.cidade} - ${matriz.estado}`}</TableCell>
                <TableCell>
                {isSempher && (
                    <Switch
                        color="primary"
                        checked={active}
                        onChange={handleToggleCompanyStatus}
                        disabled={!canUpdate}
                    />
                    )}
                </TableCell>
                <TableCell>
                    <Switch
                        color="primary"
                        checked={livenessCheck}
                        onChange={handleToggleCompanyLivenessCheck}
                        disabled={!canUpdate}
                    />
                </TableCell>
                {/*{dadosUsuario.isSempher ? (*/}
                {/*    <TableCell>*/}
                {/*        <Switch*/}
                {/*            checked={equipmentSelection}*/}
                {/*            onChange={handleToggleCompanyEquipmentSelection}*/}
                {/*            disabled={!hasPermission(["admin", "admin_empresas", "update_empresas"]) || !actionsAllowed}*/}
                {/*        />*/}
                {/*    </TableCell>*/}
                {/*) : <TableCell></TableCell>}*/}
                <TableCell align="left">
                    <Stack direction="row" justifyContent="flex-end">
                        {hasPermission(["admin", "admin_empresas", "create_empresas"]) && actionsAllowed &&
                            <Tooltip title="Adicionar Filial">
                                <span>
                                  <IconButton
                                aria-label="Adicionar"
                                color="primary"
                                onClick={() => handleOpenModalFilial(null)}
                                disabled={!active || (isLimitReached && !dadosUsuario?.isSempher)}
                            >
                                <Add />
                            </IconButton>
                                </span>
                            </Tooltip>
                        }

                        {hasPermission(["admin", "admin_empresas", "delete_empresas"]) &&
                            <Tooltip title={actionsAllowed ? "Editar Matriz" : "Visualizar Matriz"}>
                                <IconButton
                                    aria-label="Editar"
                                    onClick={handleOpenEditForm}
                                >
                                    {actionsAllowed ? <EditIcon /> : <Visibility color='primary' />}
                                </IconButton>
                            </Tooltip>
                        }

                        {hasPermission(["admin", "admin_empresas", "delete_empresas"]) && actionsAllowed &&
                            <Tooltip title="Excluir Matriz">
                                <IconButton
                                    aria-label="Excluir"
                                    onClick={() => setOpenDialog(true)}
                                >
                                    <TrashIcon />
                                </IconButton>
                            </Tooltip>
                        }
                    </Stack>
                </TableCell>
            </TableRow>

            {open && (
                <CompanyUnits
                    filiais={filiais}
                    loaded={loaded}
                    handleCarregaFiliais={carregaFiliais}
                    handleOpenModalFilial={handleOpenModalFilial}
                />
            )}

            <ConfirmDialog
                description={'Tem certeza que deseja excluir esta empresa?'}
                title={'Excluir Empresa'}
                goAction={() => deleteEmpresa(matriz.id)}
                handleClose={setOpenDialog}
                state={openDialog}
            />
        </>
    );
};

function Companies() {
    const { dadosUsuario } = useAppContext();
    const isSempher = useIsSempher();
    const { exibirAlerta } = useCommonItems();
    const { verifyIntegrationMode } = useModuleContext();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [numTotalItems, setNumTotalItems] = useState(0);

    const [matrizes, setMatrizes] = useState([]);
    const [open, setFormOpen] = useState(false);
    const [companyType, setCompanyType] = useState('matriz');
    const [matrizParentFilial, setMatrizParentFilial] = useState(null);
    const [isMaxEmpresas, setIsMaxEmpresas] = useState(true);

    const [isLoading, setIsLoading] = useState(true);

    const [isOpenFilters, setIsOpenFilters] = useState(false);
    const [activeFilters, setActiveFilters] = useState(0);

    const [company, setCompany] = useState(null);

    const [searchParams, setSearchParams] = useSearchParams();
    const nome = searchParams.get('nome');

async function carregaMatrizes() {
    const timer = setTimeout(() => setIsLoading(true), 500);
    try {
        const res = await listaEmpresas('matriz', page, rowsPerPage, true, nome);

        setMatrizes(
            res.data.data.map((m) => ({ ...m, hasUnites: Boolean(m.hasUnites) }))
        );
        setNumTotalItems(res.data.numero_total);
    } catch (error) {
        exibirAlerta('Erro', 'Erro ao carregar empresas', 'error');
    } finally {
        clearTimeout(timer);
        setIsLoading(false);
    }
}

    const updateCompanyStatus = (companyId, status) => setMatrizes((prev) =>
        prev.map((matriz) => matriz.id === companyId ? { ...matriz, status } : matriz)
    );

    const updateCompanyLivenessCheck = (companyId, livenessCheck) => setMatrizes((prev) =>
        prev.map((matriz) => matriz.id === companyId ? { ...matriz, livenessCheck } : matriz)
    );

    useEffect(() => {
        if (!open) {
            carregaMatrizes();
            setCompany(null);
            setMatrizParentFilial(null);
            setCompanyType('matriz');
        }
    }, [open, page, rowsPerPage, searchParams]);

    useEffect(() => {
        const requiredPermissionsView = ["admin", "admin_empresas", "list_empresas"];
        checkPermissionsAndRedirect(requiredPermissionsView);
    }, []);

    useEffect(() => {
        const fetchContrato = async () => {
            try {
                const limitReached = await checkMaxEmpresas(numTotalItems, { isFilter: true });
                setIsMaxEmpresas(limitReached);
            } catch (error) {
                exibirAlerta('Erro', 'Erro ao verificar limite de empresas:', 'error');
                console.error('Erro ao verificar limite de empresas:', error);
            }
        };
        fetchContrato();
    }, [numTotalItems]);

    return (
        <>
            <Helmet title="Empresas" defer={false} />

            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="end"
                spacing={3}
            >
                <Grid item xs={12} md={9}>
                    <Breadcrumbs>
                        <LinkNavegacao to="/"><HomeIcon fontSize="small" /></LinkNavegacao>
                        <Typography variant='span'>Gerenciamento</Typography>
                        <Typography variant='span'>Empresas</Typography>
                    </Breadcrumbs>

                    <PageTitle
                        icon={<OfficeIcon fontSize="large" />}
                        title='Empresas'
                        description=' Administre Empresas Matrizes/Filiais e seus detalhes'
                    />
                </Grid>

                <Grid item xs={12}>
                    <Stack direction={{ xs: 'column-reverse', md: 'row' }} spacing={2} justifyContent='space-between' alignItems='center'>
                        <FiltersButton
                            isOpenFilters={isOpenFilters}
                            setIsOpenFilters={setIsOpenFilters}
                            activeFilters={activeFilters}
                        />

                        {hasPermission(["admin", "admin_empresas", "create_empresas"]) &&
                            <Grid item xs={12} md={3}>
                                <Typography
                                    sx={{
                                        textAlign: {
                                            xs: 'center',
                                            md: 'right'
                                        }
                                    }}
                                >
                                    <TooltipSelectDisabled isDisabled={!isMaxEmpresas || isSempher} text="Limite máximo de empresas atingido">
                                        <Button
                                            variant="contained"
                                            startIcon={<Add />}
                                            onClick={() => setFormOpen(true)}
                                            disabled={isMaxEmpresas && !isSempher}
                                        >
                                            Cadastrar Empresa
                                        </Button>
                                    </TooltipSelectDisabled>
                                </Typography>
                            </Grid>
                        }
                    </Stack>
                </Grid>

                <CompanyTableFilter
                    isOpenFilters={isOpenFilters}
                    isLoadingList={isLoading}
                />

                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        <Table aria-label="Empresas">
                            <TableHead>
                                <TableRow>
                                    <TableCell />
                                    <TableCell>Filiais</TableCell>
                                    <TableCell>CNPJ</TableCell>
                                    <TableCell>Nome Fantasia</TableCell>
                                    <TableCell>Cidade/Estado</TableCell>
                                    {isSempher ? ( 
                                    <TableCell>Status</TableCell>
                                    ) :(
                                        <TableCell/>
                                    )}
                                    <TableCell>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 0.75,
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            Detecção de Vivacidade
                                            <Tooltip title="Este recurso analisa se a biometria enviada corresponde a uma
                                                            pessoa real. Ele evita acessos indevidos por falsificação de
                                                            imagens (foto impressa, vídeos, máscaras, etc.), garantindo
                                                            maior segurança no processo de autenticação.
                                                            Observação: com o recurso ativado, a validação pode não ser
                                                            concluída caso haja baixa luminosidade, uso de acessórios que
                                                            cubram o rosto, ou má qualidade da câmera">
                                                <Info fontSize="small" sx={{ cursor: 'pointer', color: 'text.disabled' }} />
                                            </Tooltip>
                                        </Box>
                                    </TableCell>
                                    {/*{dadosUsuario.isSempher ? (*/}
                                    {/*    <TableCell>*/}
                                    {/*        <Box*/}
                                    {/*            sx={{*/}
                                    {/*                display: 'flex',*/}
                                    {/*                alignItems: 'center',*/}
                                    {/*                gap: '1rem',*/}
                                    {/*                whiteSpace: 'nowrap',*/}
                                    {/*            }}*/}
                                    {/*        >*/}
                                    {/*            <Tooltip title="Este recurso permite o controle da obrigatoriedade de seleçãp*/}
                                    {/*                            de equipamentos no balcão web">*/}
                                    {/*                <Info sx={{ cursor: 'pointer' }} />*/}
                                    {/*            </Tooltip>*/}
                                    {/*            Seleção obrigatória de equipamentos*/}
                                    {/*        </Box>*/}
                                    {/*    </TableCell>*/}
                                    {/*) : <TableCell></TableCell>}*/}
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isLoading ?
                                    <LoadingTableRow />
                                    : matrizes && matrizes.length > 0 ?
                                        matrizes?.map((matriz) => (
                                            <Row
                                                key={matriz.id}
                                                matriz={matriz}
                                                filiais={matriz.filiais}
                                                isSempher={isSempher}
                                                handleExibirAlerta={exibirAlerta}
                                                handleUpdateCompanyStatus={updateCompanyStatus}
                                                handleUpdateCompanyLivenessCheck={updateCompanyLivenessCheck}
                                                isLimitReached={isMaxEmpresas}
                                                handleOpenEditForm={() => {
                                                    setCompany(matriz);
                                                    setFormOpen(true);
                                                }}
                                                handleOpenModalFilial={(filial) => {
                                                    setCompanyType('filial');
                                                    setCompany(filial);
                                                    setMatrizParentFilial(matriz);
                                                    setFormOpen(true);
                                                }}
                                                actionsAllowed={verifyIntegrationMode("Empresa", matriz.id)}
                                                dadosUsuario={dadosUsuario}
                                            />
                                        ))
                                        : <EmptyTableRow colSpan={7} />
                                }
                            </TableBody>
                        </Table>

                        <CustomTablePagination
                            numTotalItems={numTotalItems}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            setPage={setPage}
                            setRowsPerPage={setRowsPerPage}
                        />
                    </TableContainer>
                </Grid>
            </Grid>

            <CompanyForm
                open={open}
                setOpen={setFormOpen}
                company={company}
                companyType={companyType}
                matrizParentFilial={matrizParentFilial}
                actionsAllowed={verifyIntegrationMode("Empresa", company?.id)}
            />
        </>
    );
}

export default Companies;